module.exports = __webpack_public_path__ + "img/rouler_positions_9.330a7225.png";